/**
 * Screen 컴포넌트
 * @description 화면 껍데기. 배경과 콘텐츠 열만 맡고 좌우는 갖지 않는다. 가로 여백은
 *   `Section` 이 정한다. 앱 `shared/ui/Screen` 의 웹 포팅 — 상태바·SafeArea 축은 웹에
 *   없어 뺐다.
 * @example
 * <Screen>
 *   <Header inset='tab'><DiscoveryHeaderSlot /></Header>
 *   <DiscoveryBody />
 * </Screen>
 */
import { memo } from "react";

import { screenStyles } from "./Screen.styles";
import type { ScreenProps } from "./Screen.types";

const Screen = memo<ScreenProps>(
  ({ children, background, hideScrollbar, testID }) => (
    <div
      className={screenStyles.root({ background, hideScrollbar })}
      data-testid={testID}
    >
      <div className={screenStyles.column}>{children}</div>
    </div>
  ),
);

Screen.displayName = "Screen";

export default Screen;
